/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_SubtitleInputs */

const cs_clients_subtitle = /** @type {(inputs: Clients_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lidé a firmy — role, poptávky a investorské profily.`)
};

const en_clients_subtitle = /** @type {(inputs: Clients_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People and companies — roles, demands, and investor profiles.`)
};

/**
* | output |
* | --- |
* | "People and companies — roles, demands, and investor profiles." |
*
* @param {Clients_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_subtitle = /** @type {((inputs?: Clients_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_subtitle(inputs)
	return cs_clients_subtitle(inputs)
});